export default __webpack_public_path__ + "static/media/addis.58b42ae1.jpg";